module.exports = __webpack_public_path__ + "img/img_avatar.a5e81f19.png";